import React, { useEffect } from 'react';
import { Routes, Route, useLocation, HashRouter } from "react-router-dom";
import HomePage from '../HomePage';
import HomePage2 from '../HomePage2';
import HomePage3 from '../HomePage3';
import AboutPage from '../AboutPage/AboutPage';
import CartPage from '../CartPage/CartPage';
import CheckoutPage from '../CheckoutPage';
import OrderRecived from '../OrderRecived';
import ServicePage from '../ServicePage/ServicePage';
import ServicePageS2 from '../ServicePageS2/ServicePageS2';
import BlogPage from '../BlogPage/BlogPage'
import BlogPageLeft from '../BlogPageLeft/BlogPageLeft'
import BlogPageFullwidth from '../BlogPageFullwidth/BlogPageFullwidth'
import BlogDetails from '../BlogDetails/BlogDetails'
import BlogDetailsFull from '../BlogDetailsFull/BlogDetailsFull'
import BlogDetailsLeftSiide from '../BlogDetailsLeftSiide/BlogDetailsLeftSiide'
import LoginPage from '../LoginPage'
import SignUpPage from '../SignUpPage'
import ForgotPassword from '../ForgotPassword'
import ServiceSinglePage from '../ServiceSinglePage/ServiceSinglePage';
import ProjectPage from '../ProjectPage/ProjectPage';
import ProjectSinglePage from '../ProjectSinglePage/ProjectSinglePage';
import TeamSinglePage from '../TeamSinglePage/TeamSinglePage';
import HydrochloricAcidPage from '../HydrochloricAcidPage/HydrochloricAcidPage';
import ActivatedCarbonPage from '../ActivatedCarbonPage/ActivatedCarbonPage';
import HydratedLimePage from '../HydratedLimePage/HydratedLimePage';
import QuickLimePage from '../QuickLimePage/QuickLimePage';
import DolomitePage from '../DolomitePage/DolomitePage';
import DiMethylSulphatePage from '../DiMethylSulphatePage/DiMethylSulphatePage';
import SodiumAluminatePage from '../SodiumAluminatePage/SodiumAluminatePage';
import DiNitroDiPhenylSulphonePage from '../DiNitroDiPhenylSulphonePage/DiNitroDiPhenylSulphonePage';
import IndustriesPage from '../IndustriesPage/IndustriesPage';
import AppointmentPage from '../AppointmentPage/AppointmentPage';
import TermPage from '../TermPage/TermPage';
import TestimonialPage from '../TestimonialPage/TestimonialPage';
import PricingPage from '../PricingPage/PricingPage';
import ErrorPage from '../ErrorPage/ErrorPage';
import ContactPage from '../ContactPage/ContactPage';
import ShopPage from '../ShopPage';
import ProductSinglePage from '../ProductSinglePage';
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

const AllRoute = () => {

  return (
    <div className="App">
      <HashRouter>
        <ScrollToTop />
        <Routes>
          <Route path='/' element={<HomePage2 />} />
          {/* <Route path='home' element={<HomePage />} /> */}
          <Route path='team-single/:id' element={<TeamSinglePage />} />
          <Route path='products/hydrochloric-acid' element={<HydrochloricAcidPage />} />
          <Route path='products/activated-carbon' element={<ActivatedCarbonPage />} />
          <Route path='products/hydrated-lime' element={<HydratedLimePage />} />
          <Route path='products/quick-lime' element={<QuickLimePage />} />
          <Route path='products/dolomite' element={<DolomitePage />} />
          <Route path='products/dimethyl-sulphate' element={<DiMethylSulphatePage />} />
          <Route path='products/sodium-aluminate' element={<SodiumAluminatePage />} />
          <Route path='products/dinitro-diphenyl-sulphone' element={<DiNitroDiPhenylSulphonePage />} />
          <Route path='home' element={<HomePage2 />} />
          <Route path='home3' element={<HomePage3 />} />
          <Route path='about' element={<AboutPage />} />
          <Route path='industries' element={<IndustriesPage />} />
          <Route path='service' element={<ServicePage />} />
          <Route path='service-s2' element={<ServicePageS2 />} />
          <Route path='service-single/:id' element={<ServiceSinglePage />} />
          <Route path='project' element={<ProjectPage />} />
          <Route path='project-single/:id' element={<ProjectSinglePage />} />
          <Route path='appointment' element={<AppointmentPage />} />
          <Route path='terms' element={<TermPage />} />
          <Route path='testimonial' element={<TestimonialPage />} />
          <Route path='shop' element={<ShopPage />} />
          <Route path='product-single/:id' element={<ProductSinglePage />} />
          <Route path='cart' element={<CartPage />} />
          <Route path='checkout' element={<CheckoutPage />} />
          <Route path='order_received' element={<OrderRecived />} />
          <Route path='contact' element={<ContactPage />} />
          <Route path='pricing' element={<PricingPage />} />
          <Route path='404' element={<ErrorPage />} />
          <Route path='blog-single/:id' element={<BlogDetails />} />
          <Route path='blog-single-left-sidebar/:id' element={<BlogDetailsLeftSiide />} />
          <Route path='blog-single-fullwidth/:id' element={<BlogDetailsFull />} />
          <Route path='blog' element={<BlogPage />} />
          <Route path='blog-left-sidebar' element={<BlogPageLeft />} />
          <Route path='blog-fullwidth' element={<BlogPageFullwidth />} />
          <Route path='login' element={<LoginPage />} />
          <Route path='register' element={<SignUpPage />} />
          <Route path='forgot-password' element={<ForgotPassword />} />
        </Routes>
      </HashRouter>

    </div>
  );
}

export default AllRoute;

